import loadView from "@/utils/load-view";
import ErrorChunkLoadFailure from "@/views/ErrorChunkLoadFailure.vue";

const routes = [
    {
        path: "/error/chunk-load-failure",
        name: "ErrorChunkLoadFailure",
        // This is not loaded in an async way by intention to have
        // the template within the already loaded code.
        component: ErrorChunkLoadFailure,
    },
    {
        path: "/error/not-found",
        name: "ErrorNotFound",
        component: loadView("ErrorNotFound"),
    },
];

export default routes;
